import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import CurrentGoals from './current-goals';
import PastGoals from './past-goals';
import GrowthGoalsUtils from './utils';

import CommonStrings from 'resources/common-strings';
import HelpBox from 'components/generic/help/index';
import RuntimeActions from 'data/app-runtime/actions';
import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';

import NoFutureTermsModal from './expanded/modals/no-future-terms-modal';

export default CreateReactClass({
    displayName: 'GrowthGoalAreas',

    propTypes: {
        currentGrowthGoals: PropTypes.instanceOf(Immutable.List),
        pastGrowthGoals: PropTypes.instanceOf(Immutable.List),
        firstOpenTerm: PropTypes.instanceOf(Immutable.Map),
        testEvents: PropTypes.instanceOf(Immutable.List),
        studentBid: PropTypes.string.isRequired,
        subject: PropTypes.instanceOf(Immutable.Map).isRequired,
        goalSettingTerms: PropTypes.instanceOf(Immutable.List),
    },

    expandFn() {
        Analytics.recordButtonClick(CommonValues.SectionIDs.growthGoals, 'expand-module');
        const targetTermNumber =
            this.props.goalSettingTerms && !this.props.goalSettingTerms.isEmpty()
                ? this.props.goalSettingTerms.first().get('termNumber')
                : null;

        if (this.props.firstOpenTerm) {
            RuntimeActions.expandModule('growth-goals', targetTermNumber, true);
        } else {
            this.refs.noFutureTermsModal
                .show()
                .then(() => {
                    /* intentionally blank */
                })
                .catch(() => {
                    /* intentionally blank */
                });
        }
    },

    helpText() {
        return (
            <div key="growth-goal-help-content">
                <p key="initial-text" className="help-box-p">
                    {CommonStrings.growthHelp.initialText}
                    <span key="help-icon-expanded-icon" className="icon icon-expand help-popup-icon-expand-gg" />
                </p>
                <div key="help-link-section" className="help-link">
                    <strong key="help-read-more">{CommonStrings.growthHelp.readMoreText}</strong>
                    <a key="help-link" href={CommonStrings.growthHelp.helpLink} target="_blank">
                        {CommonStrings.growthHelp.helpText}
                    </a>
                </div>
            </div>
        );
    },

    render() {
        let pastGoals = [];
        let rowIndex = 0;

        if (this.props.pastGrowthGoals && !this.props.pastGrowthGoals.isEmpty()) {
            const pastGrowthGoals = this.props.pastGrowthGoals
                .sortBy((s) => s.get('endTermNumber'))
                .reverse()
                .slice(0, 2);
            pastGrowthGoals.map(function(goal) {
                const goalStatus = GrowthGoalsUtils.goalStatus(goal);

                pastGoals.push(<PastGoals pastGrowthGoal={goal} goalStatus={goalStatus} key={rowIndex++} />);
            });
        }

        if (pastGoals.length === 0) {
            pastGoals = <PastGoals pastGrowthGoal={null} goalStatus={null} key="no-previous-goals" />;
        }

        const noFutureTermsModal = (
            <NoFutureTermsModal key="no-future-terms-modal" ref="noFutureTermsModal" subject={this.props.subject} />
        );
        return (
            <div className="module growth-goals">
                <header>Growth Goals</header>
                <span key="header-expand-btn" className="icon icon-expand" onClick={this.expandFn} />
                <HelpBox
                    id={'growth-goal-help-box-' + this.props.studentBid}
                    appLevelCssClassName="show-normal-growth-goal-help-box"
                    helpContentsRenderer={this.helpText}
                    moduleName={CommonValues.SectionIDs.growthGoals}
                    helpLabel="growth-goals-default-help"
                />
                <CurrentGoals
                    currentGrowthGoals={this.props.currentGrowthGoals}
                    firstOpenTerm={this.props.firstOpenTerm}
                    testEvents={this.props.testEvents}
                    goalSettingTerms={this.props.goalSettingTerms}
                    key="current-goal-row"
                />
                <h5 key="past-goals-header" className="past-goals-header">
                    Past Goals
                </h5>
                {pastGoals}
                {noFutureTermsModal}
            </div>
        );
    },
});
